import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchData, fetchDatasearch2 } from '../reduxactions/organizationactions/OrgSearchfundActions';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
// import '../../OrgSearchFundmanager.css';

import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';

var imageName = require('./../assets/images/person.png')

var imageuser = require('../assets/images/images.png');

interface CountryData {
    CountryID: string; // Change the type accordingly
    CountryName: string; // Change the type accordingly
}
export const OrgSearchFundmanager = () => {


    const dispatch = useDispatch()
    useEffect(() => {
        const storedCatId = sessionStorage.getItem('catid');
        const storedFirstName = sessionStorage.getItem('firstname');
        const storedLocation = sessionStorage.getItem('location');

        if (storedCatId !== null && storedCatId !== 'undefined') {
            setNeedIds(storedCatId);
        }

        if (storedFirstName !== null && storedFirstName !== 'undefined') {
            setNames(storedFirstName);
        }

        if (storedLocation !== null && storedLocation !== 'undefined') {
            setLocations(storedLocation);
        }
    }, []);
    const [needIds, setNeedIds] = useState('');
    const [orgnames, setNames] = useState('');
    const [locations, setLocations] = useState('');

    const [datas, setData] = useState<CountryData[]>([]);
    const [CountryID, setSelectedCountry] = useState<CountryData | null>(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [firstname, setName] = useState('');
    const [location, setLocation] = useState('');


    const countrylist = useSelector((state: RootState) => state.orgcountry.countrylist);
    const dataviewed = useSelector((state: RootState) => state.newdonationreducer.dataview2);


    window.sessionStorage.setItem('catid', String(CountryID));
    window.sessionStorage.setItem('firstname', firstname);
    window.sessionStorage.setItem('location', location);

    const uid = window.sessionStorage.getItem('uid');

    // To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData() as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }

    // To get data
    const fetchDataAsyncearch = async () => {
        try {
            let catIds;
            let firstnames;
            let locationss;
            if (sessionStorage.getItem('catid') !== null) {
                const catIds = window.sessionStorage.getItem('catid');
            }
            if (sessionStorage.getItem('firstname') !== null) {
                const firstnames = window.sessionStorage.getItem('firstname');
            }
            if (sessionStorage.getItem('location') !== null) {
                const locationss = window.sessionStorage.getItem('location');
            }
            await dispatch(fetchDatasearch2(uid, catIds, firstnames, locationss) as any);

        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();

    }, [dispatch])

    const navigate = useNavigate();
    //To open view
    const applyApplication = (response: any) => {
        const url = `/applyapplication/${response.fundman_id}`;
        console.log('Row ID:', response.fundman_id);

        // Use navigate to navigate to the URL
        navigate(url);
    };

    const viewuploaddata = async () => {
        try {
            await dispatch(fetchDatasearch2(uid, CountryID?.CountryID, firstname, location) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }

    const isSearchButtonVisible = CountryID !== null || firstname !== '' || location !== '';

    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/Addorg-applications.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-9">
                                        <h1>Search Fund Manager</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="content">
                            <div className="container-fluid">
                                <Panel header="">
                                    <div className="grid">
                                        <div className="col-12 md:col-6 lg:col-3">
                                            <label ><h3>Country</h3></label>
                                            <br></br>
                                            <div className="card">
                                                <span className="p-float-label">
                                                    <Dropdown value={CountryID} data-testid="country-selet" className="w-full mb-3" onChange={(e: DropdownChangeEvent) => setSelectedCountry(e.value)} options={countrylist} optionLabel="CountryName" placeholder="Select a Country" />
                                                </span>

                                            </div>
                                        </div>

                                        <div className="col-12 md:col-6 lg:col-3">
                                            <label ><h3>Fundmanager Name</h3></label>
                                            <br></br>
                                            <InputText id="name" type="text" style={{ width: '5rem' }} data-testid="fundname-input" placeholder="Fundmanager Name" className="w-full mb-3" onChange={(e) => setName(e.target.value)} />
                                        </div>

                                        <div className="col-12 md:col-6 lg:col-3">
                                            <label ><h3>Fundmanager Location</h3></label>
                                            <br></br>
                                            <InputText id="name" type="text" data-testid="fundlocation-input"  placeholder="Fundmanager Location" className="w-full mb-3" onChange={(e) => setLocation(e.target.value)} />
                                        </div>

                                        <div className="col-12 md:col-6 lg:col-2">
                                            <br></br>
                                            <br></br>

                                            <Button
                                                icon="pi pi-search"
                                                label="Search"
                                                data-testid="search-btn" 
                                                rounded
                                                outlined
                                                onClick={viewuploaddata}
                                                disabled={!isSearchButtonVisible}
                                            />


                                        </div>
                                    </div>
                                </Panel>
                            </div >
                        </section >
                        <section className="content">
                            <div className="container-fluid">
                                <div className="grid">
                                    {dataviewed.map((response: any,index:any) => (
                                        <div className="col-12 lg:col-4">
                                            <Card title="" className='border-blue-300 surface-overlay border-3 border-round font-bold m-2' >

                                                <div className="float-right badge ">
                                                    <div className="image-container">


                                                        <a key={response.id}>
                                                            {response.photo && response.photo.includes('/profile/') && response.photo.split('/profile/')[1].trim() === '' ? (


                                                                <img src={imageuser} style={{ width: '150px', height: '150px', borderRadius: '50%' }} className="profile-user-img img-responsive img-circle" />




                                                            ) : (

                                                                <img src={response.photo} style={{ width: '150px', height: '150px', borderRadius: '50%' }} className="profile-user-img img-responsive img-circle" />


                                                            )}
                                                        </a>
                                                    </div>
                                                    <h5 className="widget-user-desc">Fund Manager</h5>

                                                </div>
                                                <div className="card-footer p-0">
                                                    <div className="p-0">
                                                        <ul className="nav flex-column">
                                                            <li className="nav-item">
                                                                <a className="nav-link">
                                                                    Name: <span>{response.name}</span>
                                                                </a>
                                                            </li>
                                                            <Button
                                                                className="btn btn-primary"
                                                                data-testid={`apply-btn-${index}`} 
                                                                label="Apply"
                                                                style={{ float: 'right' }}
                                                                onClick={() => applyApplication(response)}

                                                            />
                                                        </ul>
                                                        <br />
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                    ))
                                    }
                                </div >
                            </div >
                        </section >
                    </div >
                </div>
            </div>
        </div>
    )
}
export default OrgSearchFundmanager

